import gql from 'graphql-tag';

const ProductsQuery = gql`
  query Products($sessionId: String!, $limit: Int, $nextToken: String) {
    products(sessionId: $sessionId, limit: $limit, nextToken: $nextToken) {
      items {
        thinkificProductId
        thinkificCourseId
        shopifyProductId
        name
        imageUrl
        instructor
        status
      }
      nextToken
    }
  }
`;

export default ProductsQuery;
